import { render, staticRenderFns } from "./CollectionShareModal.vue?vue&type=template&id=7cb1d0c8"
import script from "./CollectionShareModal.vue?vue&type=script&lang=js"
export * from "./CollectionShareModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports